<template>
  <!-- <v-row no-gutters> -->
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-on="on"
        v-bind="attrs"
        v-if="!timerPage"
        v-model.trim="search"
        @keydown.enter.prevent="onChange"
        class="mr-5 searchField"
        dense
        single-line
        :label="$t('menu.globalSearch')"
        filled
        hide-details=""
        clearable
      >
        <template v-slot:prepend-inner>
          <v-icon class="mr-2" size="20" color="neutralGray"
            >mdi-magnify</v-icon
          >
        </template>
      </v-text-field>
    </template>
    <span>{{ $t("menu.globalSearchTooltip") }} </span>
  </v-tooltip>

  <!-- <v-col cols="10" class="search-section">
      <v-text-field
        :label="$t('menu.globalSearch')"
        single-line
        solo
        dense
        hide-details
        clearable
        v-model.trim="search"
        @keydown.enter.prevent="onChange"
        style="height: 32px"
      />
    </v-col>
    <v-col cols="1">
      <v-btn
        dark
        height="32px"
        class="minWidth broder-redius"
        color="pageHeader"
        @click="onChange"
      >
        <v-icon left class="ma-0 pa-0" color="white"> mdi-magnify </v-icon>
      </v-btn>
    </v-col> -->
  <!-- </v-row> -->
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import _ from "lodash";

export default {
  name: "GlobalSearchText",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      // searchText: "",
    };
  },
  watch: {
    $route: {
      immediate: true, 
      handler(val){
        if(val.path !== "/search" || val.name !== "GlobalSearch") {
          this.setSearchText("");
        }
      }
    }
  },
  computed: {
    ...mapState({
      searchText: (state) => state.search.searchText,
    }),
    search: {
      get() {
        return this.searchText;
      },
      set(value) {
        this.setSearchText(value || "");
      },
    },
    timerPage() {
      return (
        this.$route.path.startsWith("/meetingTimer/") ||
        this.$route.path.startsWith("/usermanual") ||
        this.$route.path.startsWith("/licensepolicy") ||
        this.$route.path.startsWith("/sessionexpired")
      );
    },
  },
  methods: {
    ...mapActions({
      getSearchResults: "search/getSearchResults",
    }),
    ...mapMutations({
      setSearchText: "search/SET_SEARCH_TEXT",
      setSearchResult: "search/GET_SEARCH_RESULT",
      setLoader: "search/SET_LOADER",
    }),
    onChange,
  },
};

async function onChange() {
  if (this.searchText !== "") {
    this.$route.path !== "/search" ? this.$eventHub.$emit("globalSearchLoader", true) : this.setLoader(true);
    const query = {
      q: this.searchText,
      skip: 0,
    };
    this.setSearchResult([]);
    await this.getSearchResults(query);
    if (this.$route.path !== "/search") {
      this.$router.push({ path: "/search" });
    }
    this.$route.path !== "/search" ? this.$eventHub.$emit("globalSearchLoader", false) : this.setLoader(false);
  }
}
</script>

<style scoped>
.searchField {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
}
.searchField /deep/ .v-label {
  line-height: 16px !important;
}
.v-text-field {
  max-width: 260px !important;
}

.v-text-field--filled.v-input--dense.v-text-field--single-line
  /deep/
  .v-input__slot {
  min-height: 34px !important;
  /* width: 240px !important; */
}

.v-text-field--filled.v-input--dense.v-text-field--single-line /deep/ .v-label {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 16px !important;
  color: var(--v-neutralGray-base) !important;
}
.v-text-field--filled {
  border-radius: 0 !important;
}

.v-system-bar .v-icon {
  margin-right: 0px;
}

.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #cccccc !important;
}
/* ::v-deep .search-section .v-input__control {
  min-height: 31px !important;
  border-top: 1px solid var(--v-pageHeader-lighten2) !important;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
::v-deep .search-section .v-input__slot {
  background: var(--v-appBar-base) !important;
}

::v-deep .search-section .v-input__append-outer {
  padding: 0px;
  margin: 0px;
  margin-top: 0px !important;
}
.minWidth {
  min-width: auto !important;
}

::v-deep .v-text-field--outlined,
.v-text-field--solo {
  border-radius: 4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 4px;
}

.broder-redius {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  padding-left: 8px !important;
  padding-right: 8px !important;
} */
</style>
